import { render, staticRenderFns } from "./SimpleRepairPlanRegisterPage.vue?vue&type=template&id=9d9e848a&scoped=true&"
import script from "./SimpleRepairPlanRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./SimpleRepairPlanRegisterPage.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleRepairPlanRegisterPage.vue?vue&type=style&index=0&id=9d9e848a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9e848a",
  null
  
)

export default component.exports